import React from 'react'
import { connect } from 'react-redux'
import $ from 'jquery'

import ProductViewMain from '../ProductView/ProductView'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import { fetchAdvancedSearchError, fetchAdvancedSearchList } from './actions'
import {
    fetchProduct,
    fetchProductError,
    fetchProductOverrides,
    errorProductOverrides
} from '../ProductView/actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './AdvancedSearch.css'
import { max } from 'moment';

var Spinner = require('react-spinkit');

let chkReturn = 0;

class AdvancedSearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            sortBy: "",
            sortOrder: "Unspecified",
            showAll: false,
            manufacturerValue: '0',
            productLineValue: '0',
            productViewMode: false
        };

        this.afterOpen = this.afterOpen.bind(this);

        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.productView = this.productView.bind(this);
        this.productViewVerify = this.productViewVerify.bind(this);

        this.closeProductView = this.closeProductView.bind(this);

        this.sortColumn = this.sortColumn.bind(this);

        this.enterKey = this.enterKey.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.setFilterData = this.setFilterData.bind(this);
        this.clearFilters = this.clearFilters.bind(this);

        this.loadMore = this.loadMore.bind(this);

        this.fetchProductErrorClear = this.fetchProductErrorClear.bind(this)
        this.errorProductOverridesClear = this.errorProductOverridesClear.bind(this)
        this.fetchAdvancedSearchErrorClear = this.fetchAdvancedSearchErrorClear.bind(this);
    }

    fetchProductErrorClear() {
        this.props.dispatch(fetchProductError);
    }

    errorProductOverridesClear() {
        this.props.dispatch(errorProductOverrides);
    }

    fetchAdvancedSearchErrorClear() {
        this.props.dispatch(fetchAdvancedSearchError);
    }

    afterOpen() {
        $('div#General').css('display', 'block')
        $('li[panel="General"]').addClass('selected')
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    selectPanel(e) {
        $('div.panelFrame').css('display', 'none')
        $('li.productview').removeClass("selected")

        e.currentTarget.className = "productview selected"

        if (e.currentTarget.value == 0)
            $('div#' + e.currentTarget.attributes["panel"].value).css('display', 'block')
        else
            $('div#' + e.currentTarget.value).css('display', 'block')

        var maxWidth = 0
        if (e.currentTarget.value == "Category" || e.currentTarget.value == 0 && e.currentTarget.attributes["panel"].value == "Category") {
            $('div#Category ul').each(function () {
                if (parseInt($(this).css('width')) > maxWidth) {
                    maxWidth = parseInt($(this).css('width'))
                }
            })

            $('div#Category ul').css('width', maxWidth.toString() + 'px')

            maxWidth += 4
            $('p.web').css('width', maxWidth.toString() + 'px')
        }
    }

    getFilters() {
        let filters = {
            manufacturerFilter: $('#manufacturer').val(),
            productLineFilter: $('#product_line').val(),

            upcFilter: $('#upc').val(),
            vendorSkuFilter: $('#vendor_sku').val(),
            reicoSkuFilter: $('#reico_sku').val(),
            productNameFilter: $('#product_name').val(),
            descriptionFilter: $('#description').val(),
        }

        if (filters.manufacturerFilter == 'Select')
            filters.manufacturerFilter = '0';
        if (filters.productLineFilter == 'Select')
            filters.productLineFilter = '0';

        return filters
    }

    productView(e) {
        if (this.props.advancedsearch.fetching) return

        fetchProduct.bind(this)(e.currentTarget.attributes.id.value);
        fetchProductOverrides.bind(this)(e.currentTarget.attributes.id.value);

        chkReturn = setInterval(this.productViewVerify, 100);
    }
    productViewVerify() {
        if ((this.props.product.fetched || this.props.product.error) &&
            (this.props.overrides.fetched || this.props.overrides.error) &&
            (this.props.template.updated || this.props.template.error)) {
            if (this.props.product.fetched && this.props.overrides.fetched && this.props.template.updated) {
                this.setState({ productViewMode: true });
            }

            clearInterval(chkReturn);
        }
    }

    closeProductView() {
        this.setState({ productViewMode: false });
    }

    sortColumn(e) {
        let sortOrder
        let sortElement = e.target.children.length === 0 ? e.target.parentElement : e.target
        let sortBy = sortElement.id
        let sort = sortElement.children[0].className.split(' ')[1]

        if (sort === "fa-sort") {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }
        else if (sort === "fa-sort-asc") {
            sortOrder = "Descending"
            sortElement.children[0].className = "fa fa-sort-desc fa-xs"
        }
        else {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }

        this.setState(
            {
                page: 1,
                sortBy: sortBy,
                sortOrder: sortOrder
            }
        );

        $('th').each(function () {
            if ($(this).attr('id') !== sortElement.id) {
                $(this).removeClass("sort")
                $($(this).children()[0]).removeClass("fa-sort-asc")
                $($(this).children()[0]).removeClass("fa-sort-desc")
                $($(this).children()[0]).addClass("fa-sort")
            }
        })

        sortElement.className = "sort"

        let filters = this.getFilters()

        filters.pageIndex = 1
        filters.sortBy = sortBy
        filters.sortOrder = sortOrder

        fetchAdvancedSearchList.bind(this)(filters);
    }

    enterKey(event)
    {
        if (event.keyCode == 13)
            this.setFilter()
    }

    processCollapse(e) {
        if (e.target.className.includes("fa-toggle-down")) {
            $("i.filter").addClass("fa-toggle-up")
            $("i.filter").removeClass("fa-toggle-down")

            $("div.col-sm-6").css("display", "block")
            $("div.under530").css("display", "block")
        }
        else {
            $("i.filter").addClass("fa-toggle-down")
            $("i.filter").removeClass("fa-toggle-up")

            $("div.col-sm-6").css("display", "none")
            $("div.under530").css("display", "none")
        }
    }

    setFilter() {
        let filters = {
            manufacturerFilter: $('#manufacturer').val(),
            productLineFilter: $('#product_line').val(),

            upcFilter: $('#upc').val(),
            vendorSkuFilter: $('#vendor_sku').val(),
            reicoSkuFilter: $('#reico_sku').val(),
            productNameFilter: $('#product_name').val(),
            descriptionFilter: $('#description').val()
        }

        if (filters.manufacturerFilter === 'Select')
            filters.manufacturerFilter = '0';
        if (filters.productLineFilter === 'Select')
            filters.productLineFilter = '0';

        $('th').each(function () {
            $(this).removeClass("sort")
            $($(this).children()[0]).removeClass("fa-sort-asc")
            $($(this).children()[0]).removeClass("fa-sort-desc")
            $($(this).children()[0]).addClass("fa-sort")
        })

        filters.pageIndex = 1;

        fetchAdvancedSearchList.bind(this)(filters);
    }
    setFilterData()
    {
        this.setState(
            {
                page: 1,
                sortBy: "",
                sortOrder: "Unspecified",
                manufacturerValue: $('#manufacturer').val(),
                productLineValue: $('#product_line').val()
            }
        );
    }
    clearFilters() {
        $('#manufacturer').val('0')
        $('#product_line').val('0')

        $('#upc').val('')
        $('#vendor_sku').val('')
        $('#reico_sku').val('')
        $('#product_name').val('')
        $('#description').val('')

        $('th').each(function () {
            $(this).removeClass("sort")
            $($(this).children()[0]).removeClass("fa-sort-asc")
            $($(this).children()[0]).removeClass("fa-sort-desc")
            $($(this).children()[0]).addClass("fa-sort")
        })

        this.setState(
            {
                manufacturerValue: $('#manufacturer').val(),
                productLineValue: $('#product_line').val()
            }
        );

        fetchAdvancedSearchList.bind(this)();
    }

    loadMore() {
        let currPage = this.state.page + 1;

        let filters = this.getFilters();

        filters.pageIndex = currPage;
        filters.sortBy = this.state.sortBy;
        filters.sortOrder = this.state.sortOrder;

        this.setState({ page: currPage });

        fetchAdvancedSearchList.bind(this)(filters);
    }

    render() {
        return (
            <div className="advancedsearch col-sm-12">
                <CommError error={this.props.advancedsearch.error} onClose={this.fetchAdvancedSearchErrorClear} />
                <CommError error={this.props.product.error} onClose={this.fetchProductErrorClear} />
                <CommError error={this.props.overrides.error} onClose={this.errorProductOverridesClear} />

                <ConfirmModal open={this.props.advancedsearch.noData} heading={"Advanced Search"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <div className="headWrapper">
                    <div className="product">
                        <h1>Advanced Search - Products</h1>
                    </div>
                </div>
                <div className="tableWrapper">
                    {
                        this.props.advancedsearch.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                    <div className="filters">
                        <p className="filter">Filter on<i className="fa fa-toggle-up filter pull-right" onClick={this.processCollapse} ></i></p>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label>Manufacturer Code(iSeries):</label>
                                    {
                                        this.props.advancedsearch.fetching ? 
                                            <select className="form-control" id="manufacturer" value={this.state.manufacturerValue} defaultValue="Select" disabled>
                                                <option>Select</option>
                                                {
                                                    this.props.advancedsearch.filters.manufacturers ?
                                                        this.props.advancedsearch.filters.manufacturers.map((opt, index) => {
                                                            return <option key={index}>{opt}</option>
                                                        })
                                                    :
                                                        null
                                                }
                                            </select>
                                        :
                                            <select className="form-control" id="manufacturer" value={this.state.manufacturerValue} defaultValue="Select" onChange={this.setFilterData}>
                                                <option>Select</option>
                                                {
                                                    this.props.advancedsearch.filters.manufacturers ?
                                                        this.props.advancedsearch.filters.manufacturers.map((opt, index) => {
                                                            return <option key={index}>{opt}</option>
                                                        })
                                                    :
                                                        null
                                                }
                                            </select>
                                    }
                                </div>
                                <div className="form-group">
                                    <label>Line Code(iSeries):</label>
                                    {
                                        this.props.advancedsearch.fetching ?                                        
                                            <select className="form-control" id="product_line" value={this.state.productLineValue} defaultValue="Select" disabled>
                                                <option>Select</option>
                                                {
                                                    this.props.advancedsearch.filters.productLines ?
                                                        this.props.advancedsearch.filters.productLines.map((opt, index) => {
                                                            return <option key={index}>{opt}</option>
                                                        })
                                                    :
                                                        null
                                                }
                                            </select>
                                        :
                                            <select className="form-control" id="product_line" value={this.state.productLineValue} defaultValue="Select" onChange={this.setFilterData}>
                                                <option>Select</option>
                                                {
                                                    this.props.advancedsearch.filters.productLines ?
                                                        this.props.advancedsearch.filters.productLines.map((opt, index) => {
                                                            return <option key={index}>{opt}</option>
                                                        })
                                                    :
                                                        null
                                                }
                                            </select>
                                    }
                                </div>
                                <div className="form-group">
                                    <label>UPC:</label>
                                    {
                                        this.props.advancedsearch.fetching ? 
                                            <input className="form-control" id="upc" defaultValue="" disabled />
                                        :
                                            <input className="form-control" id="upc" defaultValue="" onKeyUp={this.enterKey} />
                                     }
                                </div>
                                <div className="form-group">
                                    <label>Vendor SKU:</label>
                                    {
                                        this.props.advancedsearch.fetching ? 
                                            <input className="form-control" id="vendor_sku" defaultValue="" disabled />
                                        :
                                            <input className="form-control" id="vendor_sku" defaultValue="" onKeyUp={this.enterKey} />
                                    }
                                </div>
                                <div className="form-group button-group over530">
                                    <div>
                                        <button className="btn btn-default" onClick={this.clearFilters}>Clear</button>
                                        <button className="btn btn-primary" onClick={this.setFilter}>Search</button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label>Reico SKU:</label>
                                    {
                                        this.props.advancedsearch.fetching ? 
                                            <input className="form-control" id="reico_sku" defaultValue="" disabled />
                                        :
                                            <input className="form-control" id="reico_sku" defaultValue="" onKeyUp={this.enterKey} />
                                    }
                                </div>
                                <div className="form-group">
                                    <label>Product Name:</label>
                                    {
                                        this.props.advancedsearch.fetching ? 
                                            <input className="form-control" id="product_name" defaultValue="" disabled />
                                        :
                                            <input className="form-control" id="product_name" defaultValue="" onKeyUp={this.enterKey} />
                                    }
                                </div>
                                <div className="form-group">
                                    <label>Description:</label>
                                    {
                                        this.props.advancedsearch.fetching ?
                                            <input className="form-control" id="description" defaultValue="" disabled />
                                        :
                                            <input className="form-control" id="description" defaultValue="" onKeyUp={this.enterKey} />
                                    }
                                </div>
                            </div>
                            <div className="form-group button-group under530">
                                <div>
                                    <button className="btn btn-default" onClick={this.clearFilters}>Clear</button>
                                    <button className="btn btn-primary" onClick={this.setFilter}>Search</button>
                                </div>
                            </div>
                            <div className="pagination">
                                {
                                    this.props.advancedsearch.pages <= this.state.page * 100 ?
                                        <p>{this.props.advancedsearch.pages} Results (Viewing 1-{this.props.advancedsearch.pages} of {this.props.advancedsearch.pages})</p>
                                    :
                                        <p>{this.props.advancedsearch.pages} Results (Viewing 1-{this.state.page * 100 > this.props.advancedsearch.pages ? this.props.advancedsearch.pages : this.state.page * 100} of {this.props.advancedsearch.pages})</p>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="table">
                        <table className="lists table table-striped">
                            <thead>
                                <tr className="head">
                                    <th id="brmfg" onClick={this.sortColumn}>Manufacturer<i className="fa fa-sort fa-xs"></i></th>
                                    <th id="brlin" onClick={this.sortColumn}>Line Code<i className="fa fa-sort fa-xs"></i></th>
                                    <th id="brpart" onClick={this.sortColumn}>Part Number<i className="fa fa-sort fa-xs"></i></th>
                                    <th id="reicoSKU" onClick={this.sortColumn}>Reico SKU<i className="fa fa-sort fa-xs"></i></th>
                                    <th id="name" onClick={this.sortColumn}>Product Name<i className="fa fa-sort fa-xs"></i></th>
                                    <th id="brprcod" onClick={this.sortColumn}>Product Code<i className="fa fa-sort fa-xs"></i></th>
                                    <th id="brupc" onClick={this.sortColumn}>UPC<i className="fa fa-sort fa-xs"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.props.advancedSearchList.map((srch, index) => {
                                        return <tr className="body" key={index} id={srch.id} onClick={this.productView}>
                                            <td>{srch.brmfg}</td>
                                            <td>{srch.brlin}</td>
                                            <td>{srch.brpart}</td>
                                            <td>{srch.reicoSKU}</td>
                                            <td>{srch.name}</td>
                                            <td>{srch.brprcod}</td>
                                            <td>{srch.brupc}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    </div>

                    {
                        this.props.advancedsearch.pages > this.state.page * 100 ?
                            <button className="btn btn-block" onClick={this.loadMore}>Load More</button>
                        :
                            null
                    }
                </div>

                <ProductViewMain
                    productName={this.props.product.product.name}
                    selectPanel={this.selectPanel}
                    isOpen={this.state.productViewMode}
                    onAfterOpen={this.afterOpen}
                    onRequestClose={this.closeProductView}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    advancedsearch: state.advancedsearch,
    filters: state.reporting.filters,
    product: state.product,
    template: state.template,
    overrides: state.overrides
});

export default connect(mapStateToProps)(AdvancedSearch)